<template>
  <div id="" style="height:600px;">
<!--    <payment :dlg_payment_model="true" :form="{}"></payment>-->
  </div>
</template>

<script>

import api from "../../api/rest";
import util from "../../api/util";
import Payment from "../../components/Payment.vue";
import Vue from "vue";

export default {
  components: {Payment},
  data() {
    return {}
  },
  methods: {}
}

</script>




// WEBPACK FOOTER //
// Message.vue?20a9e1a3